var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 426.783,
    y2: 377.614
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9403e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f77953"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f79808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edbb0b"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.982,
    x2: 255.982,
    xlinkHref: "#lg1",
    y1: 377.592,
    y2: 156.34
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    xlinkHref: "#lg1",
    y1: 158.469,
    y2: 85.217
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.834,
    x2: 78.834,
    xlinkHref: "#lg1",
    y1: 227.357,
    y2: 154.104
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.166,
    x2: 433.166,
    xlinkHref: "#lg1",
    y1: 227.357,
    y2: 154.104
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 340.152,
    y2: 239.988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0168,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f2f2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2_Premium_Content"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m393.441 402.179c0 13.434-10.864 24.604-24.567 24.604h-225.749c-13.565 0-24.566-11.001-24.566-24.604 0-13.334 10.811-24.566 24.566-24.566h225.749c13.566.001 24.567 11.002 24.567 24.566z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.147 224.981-4.822 12.736-47.762 126.228-5.186 13.646h-212.791l-5.185-13.646-47.763-126.227-4.822-12.736c7.187-2.73 13.282-7.642 17.467-13.92 4.185 2.138 8.37 4.003 12.555 5.686 43.668 16.876 87.154 4.458 115.766-48.126 2.138-3.866 4.139-7.96 6.095-12.281 3.867 1.365 8.006 2.092 12.282 2.092 4.321 0 8.506-.727 12.327-2.092 1.956 4.321 3.957 8.416 6.095 12.281 28.658 52.63 72.098 65.002 115.766 48.126 4.185-1.683 8.37-3.548 12.555-5.686 4.186 6.277 10.236 11.144 17.423 13.919z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.626 121.824c0 20.218-16.389 36.645-36.644 36.645-20.218 0-36.608-16.427-36.608-36.645s16.39-36.608 36.608-36.608c20.255.001 36.644 16.39 36.644 36.608z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.46 190.712c0 20.218-16.39 36.645-36.644 36.645-20.218 0-36.608-16.427-36.608-36.645s16.39-36.608 36.608-36.608c20.255 0 36.644 16.39 36.644 36.608z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.792 190.712c0 20.218-16.389 36.645-36.644 36.645-20.218 0-36.608-16.427-36.608-36.645s16.39-36.608 36.608-36.608c20.255 0 36.644 16.39 36.644 36.608z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.616 290.07c0 27.657-15.511 50.082-34.616 50.082s-34.617-22.425-34.617-50.082c0-27.656 15.511-50.082 34.617-50.082 19.105 0 34.616 22.426 34.616 50.082z",
    fill: "url(#SVGID_6_)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProIcon);
export default __webpack_public_path__ + "static/media/pro-icon.52f510423d6a6bf13215502f613ed055.svg";
export { ForwardRef as ReactComponent };